import React from "react"
import NumberFormat from "react-number-format"
import "./NumberField.css"

function NumberField(props) {
  const {
    field: { name, value, onChange, onBlur },
    form: { touched, errors }
  } = props

  function getError(touched, errors, name) {
    return (
      (touched[name] && errors[name]) ||
      (getNested(touched, name) && getNested(errors, name))
    )
  }

  function getNested(theObject, path, separator) {
    try {
      separator = separator || "."

      return path
        .replace("[", separator)
        .replace("]", "")
        .split(separator)
        .reduce(function(obj, property) {
          return obj[property]
        }, theObject)
    } catch (err) {
      return undefined
    }
  }

  const error = getError(touched, errors, name)

  let status = "default"
  if (error) {
    status = "has-error"
  } else if (
    (touched[name] || getNested(touched, name)) &&
    value &&
    value.length &&
    (!errors[name] || !error)
  ) {
    status = "is-fixed"
  }

  return (
    <>
      <div className={`NumberField ${status}`}>
        <NumberFormat
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          name={name}
          {...props}
        />
        {error && <div className="error-message">{error}</div>}
      </div>
    </>
  )
}

export default NumberField
